import { queryClient } from '@/lib/query-client';
import { queryKeys } from '@/lib/query-keys';
import { useAuthStore } from '@/stores/auth-store';
import type { AuthResult, MeResult } from '@/types/auth';

/**
 * Aplica la respuesta de `login` / `register` (las dos devuelven lo mismo: `AuthResult`).
 *
 * Hace dos cosas, en este orden:
 *  1. Guarda la sesión en el store (token + usuario + tenants). `setSession` además elige el
 *     tenant activo, así que el panel entra ya con un negocio seleccionado.
 *  2. Siembra la caché de `GET /api/auth/me` con esa misma respuesta. `RequireAuth` usa esa
 *     query como puerta de entrada: al encontrarla ya con datos (y con el `staleTime` de
 *     `useMe`, 5 min) el usuario cae directo en el panel en vez de ver el "Cargando tu
 *     sesión…" después de cada login.
 *
 * No hay riesgo de datos viejos: si la respuesta real de `/me` llega más tarde (recarga de
 * la página), pisa la caché y `useMe` vuelve a sincronizar el store con los datos frescos.
 */
export function applyAuthResult(result: AuthResult): void {
  useAuthStore.getState().setSession({
    token: result.token,
    user: result.user,
    tenants: result.tenants,
  });

  const meData: MeResult = { user: result.user, tenants: result.tenants };
  queryClient.setQueryData(queryKeys.auth.me(), meData);
}
